import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable()
export class EnglishFallbackMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    const key = params.key;
    const currentLang = params.translateService.currentLang;
    const allTranslations = params.translateService.translations || {};

    const translationsLoaded = Object.keys(allTranslations).length > 0;
    if (!translationsLoaded) {
      console.warn(`Translations not loaded yet for key: "${key}"`);
      return key;
    }

    const translationInfo = this.findTranslationSource(key, params.translateService);
    if (translationInfo.isTranslatedValue) {
      // console.log(`🔄 DOUBLE TRANSLATION DETECTED: "${key}" is already translated from "${translationInfo.originalKey}" in ${translationInfo.sourceLang}`);
      return key;
    }

    const currentTranslations = allTranslations[currentLang];
    if (currentTranslations && (currentTranslations as any)[key]) {
      return (currentTranslations as any)[key];
    }

    if (currentLang !== 'en') {
      const englishTranslations = allTranslations['en'];
      if (englishTranslations && (englishTranslations as any)[key]) {
        // console.log(`📝 FALLBACK TO ENGLISH: "${key}" not found in ${currentLang}, using English translation`);
        return (englishTranslations as any)[key];
      }
    }
    
    if (currentLang === 'en') {
      const englishTranslations = allTranslations['en'];
      if (englishTranslations && (englishTranslations as any)[key]) {
        return (englishTranslations as any)[key];
      }
    }
    
    // console.log(`❌ MISSING TRANSLATION: "${key}" not found in any language`);
    // console.log(`   Current language: ${currentLang}`);
    // console.log(`   Available languages: ${Object.keys(allTranslations).join(', ')}`);

    return key;
  }

  /**
   * Check if the given key is actually a translated value and find its source
   */
  private findTranslationSource(key: string, translateService: any): {
    isTranslatedValue: boolean;
    originalKey?: string;
    sourceLang?: string;
  } {
    const allTranslations = translateService.translations || {};

    for (const langCode of Object.keys(allTranslations)) {
      const translations = allTranslations[langCode];
      if (translations) {
        for (const translationKey of Object.keys(translations)) {
          if (translations[translationKey] === key) {
            return {
              isTranslatedValue: true,
              originalKey: translationKey,
              sourceLang: langCode
            };
          }
        }
      }
    }

    return { isTranslatedValue: false };
  }
}